import { Box, Tooltip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { ReactNode } from "react";

import type { MetaTone } from "./MetaPill";

export interface SoftTagProps {
  label: ReactNode;
  icon?: ReactNode;
  tone?: MetaTone;
  title?: string;
  /** Monospace for identifiers such as bot names. */
  mono?: boolean;
}

/** A flat, tinted tag - the same visual family as the progress bar and the
 * header tiles, for the facts listed next to a job's bar. */
export default function SoftTag({ label, icon, tone = "neutral", title, mono = false }: SoftTagProps) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const main = tone === "neutral" ? theme.palette.text.secondary : theme.palette[tone].main;
  const body = (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 0.9,
        py: 0.3,
        borderRadius: 1,
        bgcolor: alpha(main, dark ? 0.22 : 0.09),
        color: tone === "neutral" ? "text.primary" : main,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.45,
        whiteSpace: "nowrap",
        fontFamily: mono ? "ui-monospace, SFMono-Regular, Menlo, monospace" : undefined,
        "& svg": { fontSize: 14, color: main, flexShrink: 0 },
      }}
    >
      {icon}
      {label}
    </Box>
  );
  return title ? <Tooltip title={title}>{body}</Tooltip> : body;
}
